import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import './App.css';
import { LanguageProvider } from './i18n/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import Product from './pages/Product';
import HowItWorks from './pages/HowItWorks';
import Integrations from './pages/Integrations';
import Pricing from './pages/Pricing';
import Enterprise from './pages/Enterprise';
import FAQ from './pages/FAQ';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import SignUp from './pages/SignUp';
import Login from './pages/Login';

const TITLES = {
  '/': 'Gyeno — Ship AI Agents Inside Salesforce',
  '/product': 'Product — Gyeno',
  '/how-it-works': 'How It Works — Gyeno',
  '/integrations': 'Integrations — Gyeno',
  '/pricing': 'Pricing — No Subscriptions, Just AI Credits — Gyeno',
  '/enterprise': 'Enterprise & Contact — Gyeno',
  '/faq': 'FAQ — Gyeno',
  '/privacy': 'Privacy Policy — Gyeno',
  '/terms': 'Terms & Conditions — Gyeno',
  '/signup': 'Sign Up — Gyeno',
  '/login': 'Sign In — Gyeno',
};

function ScrollAndTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = TITLES[pathname] || 'Gyeno';
  }, [pathname]);
  return null;
}

function LenisProvider({ children }) {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, wheelMultiplier: 1 });
    let raf;
    function loop(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return children;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <LenisProvider>
            <ScrollAndTitle />
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/product" element={<Product />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/integrations" element={<Integrations />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/enterprise" element={<Enterprise />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/login" element={<Login />} />
              </Routes>
            </main>
            <Footer />
            <CookieConsent />
            <Toaster position="top-center" richColors />
          </LenisProvider>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
